export const siteConfig = {
  name: '九游娱乐',
  tagline: '官方平台，海量游戏娱乐体验',
  description: '九游娱乐是您首选的综合娱乐平台，提供海量精品游戏、丰厚奖励活动与极致娱乐体验。九游娱乐汇聚顶级游戏资源，安全稳定，24小时客服在线，新用户注册即享专属福利，立即加入九游娱乐，开启您的娱乐新旅程。',
  url: 'https://www.9game.com',
  keywords: '九游娱乐,九游娱乐官网,九游娱乐平台,九游娱乐注册,九游娱乐游戏大厅,九游娱乐优惠活动,九游娱乐手机版',
  email: 'service@9game.com',
  phone: '400-888-9999',
  address: '广东省广州市天河区珠江新城华夏路30号',
  workingHours: '周一至周日 09:00 - 24:00',
  socialLinks: {
    weibo: '#',
    wechat: '#',
    qq: '#',
  },
};